import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 80 80',
  width = '80',
  className = '',
  height = '80',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g transform="translate(-202.002 -49.996)">
      <path
        fill={fill}
        style={{opacity: '.15'}}
        d="M15707 22588a39.9 39.9 0 1 1 15.569-3.145A39.735 39.735 0 0 1 15707 22588zm0-76a35.875 35.875 0 1 0 14.012 2.828A35.8 35.8 0 0 0 15707 22512z"
        transform="translate(-15465.002 -22458.004)"
      />
      <path
        fill={fill}
        d="M15721 22548h-4a35.974 35.974 0 0 0-36-36v-4a39.976 39.976 0 0 1 40 40z"
        transform="translate(-15439.002 -22458)"
      />
    </g>
  </svg>
);
export default SVG;
